export default "__VITE_ASSET__WS9s89sb__"